export const ACTIVE = 0;
export const DEACTIVE = 1;
export const TRANSFERRING = 2;

export default {
  ACTIVE,
  DEACTIVE,
  TRANSFERRING
};
